import { Converter } from '../types/converter';

export const luminanceConverter: Converter = {
  id: 'luminance',
  name: 'Luminance Converter',
  icon: 'Sun',
  categories: ['light'],
  units: [
    { name: 'Candela/square meter', symbol: 'cd/m²', factor: 1 },
    { name: 'Candela/square centimeter', symbol: 'cd/cm²', factor: 10000 },
    { name: 'Candela/square foot', symbol: 'cd/ft²', factor: 10.7639 },
    { name: 'Candela/square inch', symbol: 'cd/in²', factor: 1550.0031 },
    { name: 'Kilocandela/square meter', symbol: 'kcd/m²', factor: 1000 },
    { name: 'Stilb', symbol: 'sb', factor: 10000 },
    { name: 'Lumen/square meter/steradian', symbol: 'lm/m²/sr', factor: 1 },
    { name: 'Lumen/square centimeter/steradian', symbol: 'lm/cm²/sr', factor: 10000 },
    { name: 'Lumen/square foot/steradian', symbol: 'lm/ft²/sr', factor: 10.7639 },
    { name: 'Watt/square centimeter/steradian (at 555 nm)', symbol: 'W/cm²/sr', factor: 6830000 },
    { name: 'Nit', symbol: 'nt', factor: 1 },
    { name: 'Millinit', symbol: 'mnt', factor: 0.001 },
    { name: 'Lambert', symbol: 'L', factor: 3183.0989 },
    { name: 'Millilambert', symbol: 'mL', factor: 3.1831 },
    { name: 'Foot-lambert', symbol: 'fL', factor: 3.4262591 },
    { name: 'Apostilb', symbol: 'asb', factor: 0.3183099 },
    { name: 'Blondel', symbol: 'blondel', factor: 0.3183099 },
    { name: 'Bril', symbol: 'bril', factor: 0.0003183099 },
    { name: 'Skot', symbol: 'skot', factor: 0.0003183099 }
  ]
};
